import React from "react";
import Chart from "react-apexcharts";
// import { Chart, HorizontalBar } from 'react-chartjs-2';

export const UsersGraphOSType = ({ dataset }) => {
  const { labels = [], value = [] } = dataset || {};
  const options = {
    colors: ["#00CD98", "#0F51A1"],

    chart: {
      id: "UsersGraphOSType",
    },
    dataLabels: {
      enabled: false,
    },
    labels: labels,
    legend: {
      show: true,
      position: "right",
      horizontalAlign: "center",
      floating: false,
      onItemClick: {
        toggleDataSeries: false,
      },
    },
  };
  const series = [
    {
      name: "scanned",
      data: value,
    },
  ];

  return <Chart options={options} series={value} type="donut" width="100%" />;
};
